// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.AllPinsFooter__container-bdf5b0 {
  padding: 0 16px;
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: var(--base-0);
  position: relative;
  z-index: 2;
  /* 72px is height of input panel*/
  height: 72px;
}

.AllPinsFooter__unpin-all-bdb909 {
  color: var(--brand-secondary-40);
  cursor: pointer;
  padding: 8px 16px;
}

.AllPinsFooter__unpin-all-bdb909:hover {
  opacity: 0.9;
}`, "",{"version":3,"sources":["webpack://./src/main/ChatView/AllPins/AllPinsFooter/AllPinsFooter.styles.m.css"],"names":[],"mappings":"AAAA;EACE,eAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,+BAAA;EACA,kBAAA;EACA,UAAA;EACA,iCAAA;EACA,YAAA;AACF;;AAEA;EACE,gCAAA;EACA,eAAA;EACA,iBAAA;AACF;;AAEA;EACE,YAAA;AACF","sourcesContent":[".container {\n  padding: 0 16px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  background-color: var(--base-0);\n  position: relative;\n  z-index: 2;\n  /* 72px is height of input panel*/\n  height: 72px;\n}\n\n.unpin-all {\n  color: var(--brand-secondary-40);\n  cursor: pointer;\n  padding: 8px 16px;\n}\n\n.unpin-all:hover {\n  opacity: 0.9;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": `AllPinsFooter__container-bdf5b0`,
	"unpin-all": `AllPinsFooter__unpin-all-bdb909`,
	"unpinAll": `AllPinsFooter__unpin-all-bdb909`
};
module.exports = ___CSS_LOADER_EXPORT___;
